import { render } from "./VideoPlayerFull.vue?vue&type=template&id=cb5fe130"
import script from "./VideoPlayerFull.vue?vue&type=script&lang=js"
export * from "./VideoPlayerFull.vue?vue&type=script&lang=js"

import "./VideoPlayerFull.vue?vue&type=style&index=0&id=cb5fe130&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__